import { Box } from '@material-ui/core'
import { Button } from 'react-admin'
import { isActionRequired, requiredActionDescription } from '../../utils'
import useStyles from '../../styles'
import { CheckCircleOutline } from '@material-ui/icons'
import Api from '../../../../Apis/api.service'
import { useState } from 'react'
import { isEmpty } from '../../../../utils'

const ButtonActionWrapper = ({
  record,
  payload = {},
  setIsError,
  setOpen,
  setMessage,
  setRefresh,
  setErrors,
  errors,
  ...props
}) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  if (!record) {
    return null
  }
  if (!isActionRequired(record.state_transition)) {
    return null
  }
  const validateFormData = () => {
    const input_columns_required = record.state_transition.input_columns.filter(
      (item) => item.required
    )
    let inputs_has_error = []
    input_columns_required.map((item) => {
      if (isEmpty(payload[item.source])) {
        inputs_has_error.push({
          id: item.id,
          source: item.source,
          type: item.type,
          label: item.label,
        })
      }
    })
    setErrors(() => {
      return [...inputs_has_error]
    })
    return !inputs_has_error.length
  }
  const can_forward = record.state_transition.can_forward
  const can_input = record.state_transition.input_columns.length > 0

  const handleOnSubmit = async (validate = false) => {
    setLoading(true)
    // VALIDATION FORM
    const valid = validateFormData()
    if (!valid) {
      setLoading(false)
      setIsError(true)
      setOpen(true)
      return
    }
    // END VALIDATION FORM

    // CHECK IF EXIST COLUMN FACTURE
    if (
      record.state_transition.input_columns.find(
        (item) => item.type == 'Facture'
      )
    ) {
      payload.hasFacture = true
    }
    // END CHECK IF EXIST COLUMN FACTURE

    // SEND TO API INVOICES
    if (payload.objFacture) {
      const resCreateInvoice = await Api.invoices.create(payload.objFacture)
      delete payload.objFacture
    }
    // END SEND TO API INVOICES

    payload = {
      validate,
      ...record,
      ...payload,
    }
    const res = await Api.tickets.updateExtranetTicket(record.id, payload)
    if (res.status == 500) {
      setIsError(true)
      setOpen(true)
      setMessage(res.data.message)
    } else {
      setIsError(false)
      setOpen(true)
      setMessage('votre modification à été effuctuée avec success.')
    }
    setLoading(() => {
      return false
    })
    setRefresh(() => {
      return new Date().getTime()
    })
  }

  const isDisabled = () => {
    return loading
    // || errors.length // disabled button when form has any error
  }

  const handleLabel = () => {
    return record.state_transition.state_button_label
      ? record.state_transition.state_button_label
      : requiredActionDescription(
          record.is_presta,
          record.state_transition.description
        )
  }
  return (
    <Box
      sx={{
        textAlign: 'right',
        marginTop: 16,
      }}
    >
      {can_forward ? (
        <Button
          label={handleLabel()}
          className={classes.button}
          disabled={isDisabled()}
          onClick={(e) => {
            e.preventDefault()
            handleOnSubmit(true)
          }}
        />
      ) : null}
      {!can_forward && can_input ? (
        <Button
          label={handleLabel()}
          className={classes.button}
          icon={<CheckCircleOutline />}
          disabled={isDisabled()}
          onClick={(e) => {
            e.preventDefault()
            handleOnSubmit()
          }}
        />
      ) : null}
    </Box>
  )
}
export default ButtonActionWrapper
